module.exports = __webpack_public_path__ + "img/start.0c87952d.png";